import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ArrowUpRightSvg } from '../../assets/arrow-up-right-icon.svg';

export const ArrowUpRightIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ArrowUpRightSvg} {...props} />;
};
